import getPageName from './getPageName';

/* Добавление контента в блок ЗП */
const career = () => {
  const pageName = getPageName(),
    career = document.querySelector("#grow");

  if (!!career == false) return;

  async function parseContent() {
    let response = await fetch("/files/career.json");
    let result = await response.json();

    result.forEach(function (el) {
      if (el.url == pageName) {
        createCareerBlock(el);
      }
    });
  }

  function createCareerBlock(data) {
    const { url, title, description, pay_1, pay_2, pay_3, IT, level, noHH } = data;

    career.innerHTML = `
              <div class="grow__container container">
                  <h2>${title}</h2>
                  <p class="grow__description">${description}</p>
                  <div class="grow__wrap">
                      <p class="grow__wrap-title">Начните этот путь, чтобы зарабатывать<br class="grow__br-mob"> уже через <span>${url == 'nutritionist' ? '3 месяца*' : ' 2-3 месяца*'}</span></p>
                      <div class="grow__block">
                          <div class="grow__block-money">
                              <div>
                                  <p>${pay_1} Рублей</p>
                                  <span>${
                                    IT == true
                                      ? "<strong>Junior</strong>"
                                      : level
                                      ? "<strong>Начальный</strong>"
                                      : ""
                                  } первые месяцы</span>
                              </div>
                              <div>
                                  <p>${pay_2} Рублей</p>
                                  <span>${
                                    IT == true
                                      ? "<strong>Middle</strong>"
                                      : level
                                      ? "<strong>Средний</strong>"
                                      : ""
                                  } от 10-12 месяцев</span>
                              </div>
                              <div>
                                  <p>${pay_3} Рублей</p>
                                  <span>${
                                    IT == true
                                      ? "<strong>Senior</strong>"
                                      : level
                                      ? "<strong>Высокий</strong>"
                                      : ""
                                  } от 24 месяцев</span>
                              </div>
                          </div>
                          <div class="grow__block-period">
                              <p>${
                                IT == true
                                  ? "<span>Junior</span>"
                                  : level
                                  ? "<span>Начальный уровень</span>"
                                  : ""
                              } первые месяцы работы</p>
                              <p>${
                                IT == true
                                  ? "<span>Middle</span>"
                                  : level
                                  ? "<span>Средний уровень</span>"
                                  : ""
                              } от 10-12 месяцев</p>
                              <p>${
                                IT == true
                                  ? "<span>Senior</span>"
                                  : level
                                  ? "<span>Высокий уровень</span>"
                                  : ""
                              } от 24 месяцев</p>
                          </div>
                      </div>
                      ${!noHH ? "<p class='grow__wrap-hh'>*по данным <a href='https://hh.ru/' target='_blank'>hh.ru</a></p>" : "<p class='grow__wrap-hh'>*по данным hh.ru</p>"}                      
                  </div>
              </div>
          `;
  }

  parseContent();
};

export default career;
